<template>
	<!-- 修改密碼 -->
	<el-dialog :close-on-click-modal="false"  title="申请权限" :visible.sync="applyRuleModel" append-to-body top="5vh" @close="hide" :width="isphone?'90%':'50%'">
		<!-- 表單内容 -->
		<el-form :rules="pass_rules" ref="pass_form" :model="apply" label-width="100px">
			
			
			<div v-if="type!='domain'" class="mb-3" style="text-align: center;">
				您暂未开通该功能权限，如需使用，请提交申请或联系管理员开通。
			</div>
		
			
			<el-form-item label="申请权限" v-if="type!='domain'" prop="">
				<el-tag  type="success">{{type=='is_match'?'比赛数据接口':'清源转推'}}</el-tag>
			</el-form-item>
			
			<el-form-item label="申请类型" v-if="type=='domain'" prop="">
				<el-tag  type="success">推拉流域名</el-tag>
			</el-form-item>
			
			
			<el-form-item v-if="type=='domain'" label="推流域名数量" prop="">
				 <el-input-number v-model="apply.push_num"  :min="1" :max="100" label="描述文字"></el-input-number>
			</el-form-item>
			
			
			<el-form-item v-if="type=='domain'" label="播放域名数量" prop="">
				 <el-input-number v-model="apply.play_num"  :min="1" :max="100" label="描述文字"></el-input-number>
			</el-form-item>
			
			
		
			
			
			<el-form-item :label="$t('accountApplyList.content')" prop="">
				<el-input type="textarea" v-model="apply.remark"  placeholder="申请原因（非必填)" size="small" style="width: 80%;"></el-input>
			</el-form-item>
			
			

			
		</el-form>


		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('system.cancel')}}</el-button>
			<el-button :loading="load" :disabled="load" type="primary" @click="submitpass">{{$t('reg.sub')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			applyRuleModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			},
			type:{
				type: String,
				default: ''
			}
		},
		data() {
			return {
				load:false,
				apply: {
					type:'',
					push_num:1,
					play_num:1,
					remark: '',
				},
				pass_rules: {
					

				},
			}
		},
		methods: {
			hide(val = 0){
				this.$emit('hide',val)
			},
			//提交
			submitpass() {
				
				this.$refs.pass_form.validate(res => {
					if (res) {
						this.apply.type = this.type
						this.submitApi()
					}
				})
				
			},
			submitApi(){
				this.load = true
				this.axios.post('/admin/user/applyLiveRule', this.apply, {
					token: true
				}).then(res => {
					this.load = false
					let all = res.data
					if (all.code == 1) {
						this.$message({
							message: all.msg,
							type: 'success'
						});
						this.hide(1)
					}
					
				}).catch(err => {
					this.load = false
				})
			}
		}
	}
</script>

<style>
	.phone_w{
		width: 90%;;
	}
	.pc_w{
		width: 34%;;
	}
</style>
